export function SvgChevron() {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6 12.6667L10.6667 8.00004L6 3.33337"
        stroke="#868E95"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
